<template>
    <div class="w-full text-center py-2 border-b cursor-pointer"
         @click="select">{{ title }}</div>
</template>

<script>
    export default {
        name: "MenuItem",
        props: ['title', 'link'],
        methods: {
            select() {
                if (this.link) {
                    this.$router.push({ name: this.link }).catch(()=>{});
                    this.$store.commit('app/hideMainMenu');
                } else {
                    this.$emit('select')
                    this.$store.commit('app/hideMainMenu');
                }
            }
        }
    }
</script>

<style scoped>

</style>